/* ==========================================================================
   ABO TALEB — product page behaviour
   Variant picking, quantity, gallery, accordions and the sticky buy bar.
   Everything degrades to a working form if this file never loads.
   ========================================================================== */
(function () {
  'use strict';

  /* More than one section on the page includes this file, and the browser runs
     every <script> tag it meets — so without this guard the whole thing booted
     twice or three times and each quantity button ended up with two or three
     click handlers (one tap on "+" jumped 1 → 4). Run once, whoever loads it. */
  if (window.__atProductBooted) return;
  window.__atProductBooted = true;

  function bound(el, key) {
    var attr = 'data-at-bound-' + key;
    if (el.hasAttribute(attr)) return true;
    el.setAttribute(attr, '1');
    return false;
  }

  /* ---------- variant picker --------------------------------------------- */
  function initVariants(root) {
    if (bound(root, 'variants')) return;
    var data = root.querySelector('[data-at-variants]');
    if (!data) return;
    var variants;
    try { variants = JSON.parse(data.textContent); } catch (e) { return; }

    var idInput = root.querySelector('[data-at-variant-id]');
    var priceEl = root.querySelector('[data-at-price]');
    var compareEl = root.querySelector('[data-at-compare]');
    var skuEl = root.querySelector('[data-at-sku]');
    var addBtn = root.querySelector('[data-at-add]');
    var addText = root.querySelector('[data-at-add-text]');
    var buyNow = root.querySelector('[data-at-buy-now]');
    var barPrice = document.querySelector('[data-at-bar-price]');
    var barSel = document.querySelector('[data-at-bar-selection]');
    var soldOut = addBtn ? addBtn.getAttribute('data-sold-out') : 'غير متاح';
    var addLabel = addBtn ? addBtn.getAttribute('data-add-label') : 'ضيف للسلة';

    function selected() {
      return Array.prototype.map.call(
        root.querySelectorAll('[data-at-option]'),
        function (group) {
          var on = group.querySelector('input:checked');
          return on ? on.value : null;
        }
      );
    }

    function match(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) {
          if (opts[j] !== null && v.options[j] !== opts[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function paint() {
      var opts = selected();
      var v = match(opts);

      /* Grey out a choice that pairs with nothing in stock. */
      root.querySelectorAll('[data-at-option]').forEach(function (group, gi) {
        group.querySelectorAll('input').forEach(function (input) {
          var probe = opts.slice();
          probe[gi] = input.value;
          var m = match(probe);
          var label = input.closest('label') || input.nextElementSibling;
          if (label) label.classList.toggle('is-unavailable', !m || !m.available);
        });
      });

      if (!v) {
        if (addBtn) addBtn.disabled = true;
        if (buyNow) buyNow.disabled = true;
        if (addText) addText.textContent = soldOut;
        return;
      }

      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = v.price_html;
      if (compareEl) {
        compareEl.innerHTML = v.compare_html || '';
        compareEl.hidden = !v.compare_html;
      }
      if (skuEl) skuEl.textContent = v.sku || '';
      if (addBtn) addBtn.disabled = !v.available;
      if (buyNow) buyNow.disabled = !v.available;
      if (addText) addText.textContent = v.available ? addLabel : soldOut;
      if (barPrice) barPrice.innerHTML = v.price_html;
      if (barSel) barSel.textContent = opts.filter(Boolean).join(' · ');

      /* Keep the URL shareable without reloading the page. */
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }

      /* Some option values name a gallery image; show it when they do. */
      var target = root.querySelector('[data-at-gallery-item][data-variant-id="' + v.id + '"]');
      if (target) target.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });

      /* Anything else on the page that mirrors the selection listens for this. */
      document.dispatchEvent(new CustomEvent('at:variant', {
        detail: { options: opts, variant: v, priceHtml: v.price_html }
      }));

      /* Per-option helper text under each picker. */
      root.querySelectorAll('[data-at-option-note]').forEach(function (note) {
        var gi = parseInt(note.getAttribute('data-at-option-note'), 10);
        var value = opts[gi];
        var line = note.querySelector('[data-value="' + value + '"]');
        note.querySelectorAll('[data-value]').forEach(function (n) { n.hidden = n !== line; });
      });
    }

    root.querySelectorAll('[data-at-option] input').forEach(function (input) {
      input.addEventListener('change', paint);
    });
    paint();
  }

  /* ---------- quantity ---------------------------------------------------- */
  function initQty(root) {
    root.querySelectorAll('[data-at-qty]').forEach(function (box) {
      if (bound(box, 'qty')) return;
      var input = box.querySelector('input');
      box.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          var step = b.getAttribute('data-at-step') === 'up' ? 1 : -1;
          var next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------- buy now -----------------------------------------------------
     One request, not two. The form posts to the cart with `return_to` set to
     the checkout, so the server adds the item and redirects there itself —
     adding first and then navigating from JavaScript made the shopper wait
     for two round trips back to back.                                       */
  function initBuyNow(root) {
    var btn = root.querySelector('[data-at-buy-now]');
    if (!btn || bound(btn, 'buynow')) return;
    var form = root.querySelector('[data-at-product-form]') || btn.closest('form');
    if (!form) return;

    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var field = form.querySelector('input[name="return_to"]');
      if (!field) {
        field = document.createElement('input');
        field.type = 'hidden';
        field.name = 'return_to';
        form.appendChild(field);
      }
      field.value = base + 'checkout';

      btn.disabled = true;
      var busy = btn.getAttribute('data-busy-label');
      if (busy) btn.textContent = busy;

      if (form.requestSubmit) form.requestSubmit();
      else form.submit();
    });
  }

  /* ---------- free shipping threshold -------------------------------------
     The box highlights once the quantity clears the threshold. The second
     message is optional — with no "you made it" line the first one simply
     stays put rather than swapping to an empty span.                        */
  function initOffer(root) {
    var offer = root.querySelector('[data-at-offer]');
    var input = root.querySelector('[data-at-qty] input');
    if (!offer || bound(offer, 'offer')) return;
    var threshold = parseInt(offer.getAttribute('data-threshold'), 10) || 0;
    var pending = offer.querySelector('[data-at-offer-text]');
    var done = offer.querySelector('[data-at-offer-done]');

    function paint() {
      var n = input ? (parseInt(input.value, 10) || 1) : 1;
      var reached = threshold > 0 && n >= threshold;
      offer.classList.toggle('is-reached', reached);
      if (pending) pending.hidden = reached && !!done;
      if (done) done.hidden = !reached;
    }

    if (input) {
      input.addEventListener('change', paint);
      input.addEventListener('input', paint);
    }
    paint();
  }

  /* ---------- accordions -------------------------------------------------- */
  function initAccordions(scope) {
    (scope || document).querySelectorAll('[data-at-accordion]:not([data-at-bound])').forEach(function (acc) {
      acc.setAttribute('data-at-bound', '1');
      var btn = acc.querySelector('[data-at-acc-toggle]');
      var body = acc.querySelector('[data-at-acc-body]');
      if (!btn || !body) return;
      btn.addEventListener('click', function () {
        var open = acc.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', String(open));
        body.hidden = !open;
      });
    });
  }

  /* ---------- gallery (mobile swipe + dots) ------------------------------- */
  function initGallery(scope) {
    (scope || document).querySelectorAll('[data-at-gallery]:not([data-at-bound])').forEach(function (g) {
      g.setAttribute('data-at-bound', '1');
      var dots = g.parentElement.querySelectorAll('[data-at-gallery-dot]');
      if (!dots.length) return;
      var items = g.querySelectorAll('[data-at-gallery-item]');
      g.addEventListener('scroll', function () {
        var i = Math.round(g.scrollLeft / (g.clientWidth || 1));
        i = Math.min(items.length - 1, Math.max(0, Math.abs(i)));
        dots.forEach(function (d, di) { d.classList.toggle('is-on', di === i); });
      }, { passive: true });
      dots.forEach(function (d, di) {
        d.addEventListener('click', function () {
          items[di].scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
        });
      });
      dots[0].classList.add('is-on');
    });
  }

  /* ---------- tabs (the "what's in your cup" panel) ----------------------- */
  function initTabs(scope) {
    (scope || document).querySelectorAll('[data-at-tabs]:not([data-at-bound])').forEach(function (wrap) {
      wrap.setAttribute('data-at-bound', '1');
      var tabs = wrap.querySelectorAll('[data-at-tab]');
      var panels = wrap.querySelectorAll('[data-at-tab-panel]');
      function show(i) {
        tabs.forEach(function (t, ti) {
          t.classList.toggle('is-on', ti === i);
          t.setAttribute('aria-selected', String(ti === i));
        });
        panels.forEach(function (p, pi) { p.hidden = pi !== i; });
      }
      tabs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
      show(0);
    });
  }

  /* ---------- sticky buy bar ---------------------------------------------
     Appears once the main buy button has scrolled away, so the phone always
     has a reachable add-to-cart without covering the picker.                */
  function initStickyBar() {
    var bar = document.querySelector('[data-at-buybar]');
    var anchor = document.querySelector('[data-at-buybar-anchor]');
    if (!bar || !anchor || bound(bar, 'buybar')) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { bar.classList.toggle('is-on', !e.isIntersecting); });
    }, { rootMargin: '-10% 0px 0px 0px' });
    io.observe(anchor);
    var proxy = bar.querySelector('[data-at-bar-add]');
    if (proxy) {
      proxy.addEventListener('click', function () {
        var real = document.querySelector('[data-at-add]');
        if (real) real.click();
      });
    }
  }

  /* ---------- selection-aware panels -------------------------------------
     Blocks opt in with data-at-token (text holding {roast}/{blend}/… ) and
     data-at-scale (a dot scale whose values differ per option value).       */
  function fillTokens(el, map) {
    var tpl = el.getAttribute('data-at-token');
    if (tpl === null) return;
    var out = tpl.replace(/\{(\w+)\}/g, function (whole, key) {
      return map[key] !== undefined && map[key] !== null ? map[key] : '';
    });
    el.textContent = out;
  }

  function bean(on, onColor, offColor, strokeColor) {
    return '<svg width="14" height="17" viewBox="0 0 14 17" aria-hidden="true">' +
      '<g transform="rotate(16 7 8.5)">' +
      '<ellipse cx="7" cy="8.5" rx="4.6" ry="6.6" fill="' + (on ? onColor : offColor) + '"></ellipse>' +
      '<path d="M7 2.6 C4.9 5.4 9.1 8.1 7 10.6 C5.3 12.7 7.4 13.9 7 14.6" stroke="' + strokeColor +
      '" stroke-width="1.4" fill="none" stroke-linecap="round"></path></g></svg>';
  }

  function paintScale(el, values) {
    var max = parseInt(el.getAttribute('data-max'), 10) || 5;
    var on = el.getAttribute('data-on-color');
    var off = el.getAttribute('data-off-color');
    var stroke = el.getAttribute('data-stroke-color');
    var idx = parseInt(el.getAttribute('data-index'), 10) || 0;
    var score = parseFloat(values[idx]);
    if (isNaN(score)) return;
    var html = '';
    for (var i = 1; i <= max; i++) html += bean(i <= score, on, off, stroke);
    el.innerHTML = html;
    var label = el.getAttribute('data-label') || '';
    el.setAttribute('aria-label', label + ': ' + score + ' من ' + max);
  }

  var selectionAwareBound = false;
  function initSelectionAware() {
    if (selectionAwareBound) return;
    selectionAwareBound = true;

    document.addEventListener('at:variant', function (e) {
      var panels = document.querySelectorAll('[data-at-selection-aware]');
      if (!panels.length) return;
      var opts = e.detail.options || [];
      panels.forEach(function (panel) {
        /* An index of -1 means "this product has no such option" — the token
           then reads as empty instead of borrowing another option's value. */
        var ri = parseInt(panel.getAttribute('data-roast-index'), 10);
        var bi = parseInt(panel.getAttribute('data-blend-index'), 10);
        var map = {
          roast: ri >= 0 ? (opts[ri] || '') : '',
          blend: bi >= 0 ? (opts[bi] || '') : '',
          price: (e.detail.priceHtml || '').replace(/<[^>]*>/g, ''),
          selection: opts.filter(Boolean).join(' · ')
        };
        panel.querySelectorAll('[data-at-token]').forEach(function (el) { fillTokens(el, map); });

        /* The picture inside the circle follows the variant: the section
           renders a {variantId: url} map, so no extra request is needed. */
        var img = panel.querySelector('[data-at-know-img]');
        if (img && e.detail.variant) {
          var imgs = null;
          try { imgs = JSON.parse(img.getAttribute('data-variant-images') || '{}'); } catch (err) { imgs = null; }
          var src = imgs && imgs[String(e.detail.variant.id)];
          if (src && img.getAttribute('src') !== src) {
            img.removeAttribute('srcset');
            img.src = src;
          }
        }

        /* Scales are keyed by one option's value — usually the blend. */
        panel.querySelectorAll('[data-at-scale-group]').forEach(function (group) {
          var sets;
          try { sets = JSON.parse(group.getAttribute('data-sets') || '{}'); } catch (err) { return; }
          var ki = parseInt(group.getAttribute('data-key-index'), 10);
          var key = ki >= 0 ? opts[ki] : undefined;
          var values = (key && sets[key]) || sets['*'];
          if (!values) return;
          group.querySelectorAll('[data-at-scale]').forEach(function (el) { paintScale(el, values); });
        });
      });
    });
  }

  function boot(scope) {
    /* The listener must exist before the picker's first paint fires at:variant,
       or the "what's in your cup" panel misses the initial selection. */
    initSelectionAware();
    var root = (scope || document).querySelector('[data-at-product]');
    if (root) { initVariants(root); initQty(root); initBuyNow(root); initOffer(root); }
    initAccordions(scope);
    initGallery(scope);
    initTabs(scope);
    initStickyBar();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
